"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotteryRoundStartButton = exports.LOTTERY_ROUND_START_DIALOG_KEY = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const startRound_json_1 = __importDefault(require("@framework/abis/json/LotteryRandom/startRound.json"));
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const round_dialog_1 = require("./round-dialog");
const utils_1 = require("../../../../../utils");
const hooks_1 = require("../../../../../hooks");
exports.LOTTERY_ROUND_START_DIALOG_KEY = "lotteryRoundStart";
const LotteryRoundStartButton = (props) => {
    const { className, contract, contract: { address, id, parameters }, disabled, variant, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openFormDialog, formDialogUniqueKey, mode } = (0, react_hooks_1.useDialogForm)();
    const { hasPermission } = (0, hooks_1.useSetButtonPermission)(types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE, contract?.id);
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        const ticket = {
            tokenType: Object.values(types_1.TokenType).indexOf(values.ticket.components[0].tokenType),
            token: values.ticket.components[0].contract.address,
            tokenId: values.ticket.components[0].templateId || 0,
            amount: 1,
        };
        const price = {
            tokenType: Object.values(types_1.TokenType).indexOf(values.price.components[0].tokenType),
            token: values.price.components[0].contract.address,
            tokenId: values.price.components[0].templateId || 0,
            amount: values.price.components[0].amount,
        };
        return writeContractAsync({
            address: address,
            abi: startRound_json_1.default,
            functionName: "startRound",
            args: [ticket, price, values.maxTicket],
        });
    });
    const handleStartRoundConfirm = async ({ data }) => {
        await metaFn(data);
    };
    const handleStartRound = () => {
        openFormDialog(`${exports.LOTTERY_ROUND_START_DIALOG_KEY}.${id}`, void 0, "button");
    };
    // round already started
    if (parameters.roundId) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleStartRound, icon: icons_material_1.PlayCircleOutline, message: "pages.lottery.rounds.start", className: className, dataTestId: "LotteryRoundStartButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract) || !hasPermission, variant: variant }), (0, jsx_runtime_1.jsx)(round_dialog_1.LotteryStartRoundDialog, { onExternalConfirm: handleStartRoundConfirm, open: formDialogUniqueKey === `${exports.LOTTERY_ROUND_START_DIALOG_KEY}.${id}.${mode}`, initialValues: {
                    contractId: id,
                    address,
                    ticket: mui_inputs_asset_1.emptyItem,
                    price: mui_inputs_asset_1.emptyPrice,
                    maxTicket: 0,
                } })] }));
};
exports.LotteryRoundStartButton = LotteryRoundStartButton;
//# sourceMappingURL=index.js.map